<template>
  <v-expand-transition>
    <div
      :id="sectionElId(section)"
      style="padding: 10px 0 10px 0;"
      v-html="section.text"
      v-if="showParagraph"
    >
    </div>
  </v-expand-transition>
</template>

<script>
import answermixin from '@/components/global/atomic/answermixin';
import { mapGetters } from 'vuex'
import GlobalConstants from '@/globals'

export default {
  name: 'UserFormParagraph',
  mixins: [answermixin],
  props: ['userFormId', 'section'],
  computed: {
    ...mapGetters('userform', [
      'answer',
      'parts'
    ]),
    showParagraph(){
      return GlobalConstants.MeetsCondition(this.section, this.answer, this.parts)
    }
  },
  methods: {
    sectionElId (section) {
      return `section-${section.id}`
    }
  }
}
</script>

<style scoped>
  div >>> p {
    margin: 0 !important;
  }
</style>